import { VendorDetail } from "@command-center-app/index";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface VendorState {
  vendorDetails: VendorDetail | null;
  vendorStatusList: { label: string; value: string }[];
  loading: boolean;
  error: string | null;
}

const initialState: VendorState = {
  vendorDetails: null,
  vendorStatusList: [],
  loading: false,
  error: null,
};

const vendorSlice = createSlice({
  name: "vendorInfo",
  initialState,
  reducers: {
    fetchVendorStart(state) {
      state.loading = true;
      state.error = null;
    },
    fetchVendorSuccess(state, action: PayloadAction<any>) {
      state.loading = false;
      state.vendorDetails = action.payload;
    },
    fetchVendorFailed(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
    setVendorStatusList(
      state,
      action: PayloadAction<{ label: string; value: string }[]>
    ) {
      state.vendorStatusList = action.payload;
    },
    clearVendor(state) {
      state.vendorDetails = null;
      state.vendorStatusList = [];
      state.error = null;
    },
  },
});

export const {
  fetchVendorStart,
  fetchVendorSuccess,
  fetchVendorFailed,
  setVendorStatusList,
  clearVendor,
} = vendorSlice.actions;

export default vendorSlice.reducer;
